import MaterialTable from 'material-table';
import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import { CENTRALIZED_LOGGER_CUSTOMER } from '../constants/ApiEndpoints';
import { makeGetRequest } from '../helpers/biztechAxiosRequest';
import moment from 'moment';
import { DD_MMM_YYYY_HH_MM_SS_A_Z } from '../constants/DateTimeFormats';

const DEPROVISIONING_CATEGORY = 'Deprovisioning';
const DEPROVISIONING_LOOKBACK_DAYS = 60;

export default class CustomerAccountLogTable extends Component {
  state = {
    isRecentDeprovisioningPresent: false
  };

  componentDidMount() {
    this.checkRecentDeprovisioning();
  }

  checkRecentDeprovisioning = () => {
    const customerAccountId = (this.props as any).customerAccountId;
    const recentDeprovisioningLogURL = `${CENTRALIZED_LOGGER_CUSTOMER}/${customerAccountId}/?pageno=1&pagesize=1&category=${DEPROVISIONING_CATEGORY}`;
    makeGetRequest(recentDeprovisioningLogURL)
      .then((result: any) => {
        const latestDeprovisioningLog = result?.data?.data?.customerLogs?.[0];
        const isRecentDeprovisioningPresent =
          !!latestDeprovisioningLog &&
          moment().diff(moment(latestDeprovisioningLog.senderTimestamp), 'days') <=
            DEPROVISIONING_LOOKBACK_DAYS;
        this.setState({ isRecentDeprovisioningPresent });
      })
      .catch(() => {
        this.setState({ isRecentDeprovisioningPresent: false });
      });
  };

  formatTimeStamp(logs: any[]): any {
    const formattedData = logs.map(log => {
      log.senderTimestamp = moment(log.senderTimestamp).format(
        DD_MMM_YYYY_HH_MM_SS_A_Z
      );
      return log;
    });
    return formattedData;
  }

  render() {
    const customerAccountId = (this.props as any).customerAccountId;
    const showEventsProvision = (this.props as any).showEventsProvision;
    const onEmergencyReprovisioningClick = (this.props as any)
      .onEmergencyReprovisioningClick;

    return (
      <MaterialTable
        title="Recent Activities"
        components={{
          Toolbar: (toolbarProps: any) => (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                padding: '16px 24px',
                boxSizing: 'border-box'
              }}
            >
              <Typography variant="h6">{toolbarProps.title}</Typography>
              {showEventsProvision && (
                <button
                  className={
                    (this.state as any).isRecentDeprovisioningPresent
                      ? 'activeButton'
                      : 'disabledButton'
                  }
                  onClick={onEmergencyReprovisioningClick}
                  disabled={!(this.state as any).isRecentDeprovisioningPresent}
                  title={
                    (this.state as any).isRecentDeprovisioningPresent
                      ? undefined
                      : `Enabled only when a Deprovisioning activity occurred in the last ${DEPROVISIONING_LOOKBACK_DAYS} days`
                  }
                >
                  Emergency Reprovisioning
                </button>
              )}
            </div>
          )
        }}
        columns={[
          {
            title: 'Category',
            field: 'category',
            grouping: false,
            sorting: false,
            render: (rowData: any) => (
              <a
                href={`#/logs/correlation/${rowData.correlationId}`}
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: 'none' }}
              >
                {rowData.category}
              </a>
            )
          },
          {
            title: 'Process',
            field: 'process',
            sorting: false
          },
          { title: 'Performed By', field: 'performedBy', sorting: false },
          {
            title: 'Date Time',
            field: 'senderTimestamp',
            width: '30%'
          }
        ]}
        data={query =>
          new Promise((resolve, reject) => {
            const centralizedLogURL = `${CENTRALIZED_LOGGER_CUSTOMER}/${customerAccountId}/?pageno=${query.page +
              1}&pagesize=${query.pageSize}`;
            makeGetRequest(centralizedLogURL)
              .then((result: any) => {
                resolve({
                  data: this.formatTimeStamp(result.data.data.customerLogs),
                  page: query.page,
                  totalCount: result.data.data.totalRecordCount
                });
              })
              .catch(error => {
                console.log(error);
                reject();
              });
          })
        }
        options={{
          search: false,
          grouping: true,
          sorting: true
        }}
      />
    );
  }
}
